import React from "react";
import { useState, useEffect, useContext, useRef } from 'react';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import styled from "styled-components";
import Responsive from "components/common/Responsive";
import SubInfo from "components/common/SubInfo";
import { PostReactions } from "./PostReactions";
import palette from "lib/styles/palette";
import client from "api/WookAxios";
import PostContext from 'post/PostContext';
import UserContext from "user/UserContext";
import userImage from "images/user.png";
import Button from 'components/common/Button';
import log from "loglevel";
import { CommentItem } from "post/CommentItem";

const PostViewerContainer = styled(Responsive)`
  margin-top: 3rem;
  // background: red;
`;

const PostHead = styled.div`
  margin: 0 1rem;
  border-bottom: 1px solid ${palette.gray[2]};
  padding-bottom: 3rem;
  margin-bottom: 3rem;
  h1 {
    font-size: 3rem;
    line-height: 1.5;
    margin: 0;
  }
`;

const SubInfoBlock = styled.div`
  margin-top: 5px;
  font-size: 15px;
  color: ${palette.gray[6]};

  span + span:before {
    color: ${palette.gray[4]};
    padding-left: 0.25rem;
    padding-right: 0.25rem;
    content: '\\B7';
  }
`;

const Author = styled.label`
  color: blue;
  font-weight: 600;
  font-size: 18px;
`;

const PostActionButtonsBlock = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: -1.5 rem;
  margin-bottom: 2rem;
  margin-right: 1rem;
  // background: red;
`;

const ActionButton = styled.button`
  padding: 0.25rem;
  border-radius: 4px;
  color: ${palette.gray[6]};
  font-weight: bold;
  border: none;
  outline: none;
  font-size: 0.875rem;
  cursor: pointer;
  &:hover {
    background: ${palette.gray[1]};
    color: hotpink;
  }
  & + & {
    margin-left: 0.25rem;
  }
`;

const PostContent = styled.div`
  // margin: 0 1rem;
  margin-top: 1rem;
  margin-bottom: 3rem;
  margin-left: 1rem;
  margin-right: 1rem;
  font-size: 1.3125rem;
  color: ${palette.gray[8]};
`;

const PostReactionsBlock = styled.div`
  // background: lightgray;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
  margin-bottom: 20px;
`;

const CommentOrder = styled.div`
  display: flex;
  width: fit-content;
  margin-top: 5px;
  margin-bottom: 0px;
  border: 1px solid ${palette.gray[3]};
  border-radius: 6px;
  overflow: hidden;
`;

const OrderButton = styled.button`
  padding: 2px 5px;
  border: none;
  background: ${({ $selected }) => $selected ? palette.gray[2] : 'white'};
  color: ${({ $selected }) => $selected ? palette.gray[8] : palette.gray[6]};
  font-size: 12px;
  white-space: nowrap;
  cursor: pointer;

  & + & {
    border-left: 1px solid ${palette.gray[3]};
  }

  &:hover {
    background: ${palette.gray[1]};
  }
`;

const CommentBlock = styled.div`
  /* background: blue; */
  display: flex;
  flex-direction: column;
  margin: 0 1rem;
  border-top: 1px solid ${palette.gray[2]};  
`;

const UserImage = styled.div`
  box-sizing: border-box;
  width: 40px;
  // height: 30px;
  margin-right: 10px;
  // margin-top: 5px;
`;

const UserURLImage = styled.div`
  box-sizing: border-box;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  margin-right: 10px;
  // background: red;
  // margin-top: 5px;
`;

const CommentButtonBlock = styled.div`
  /* background: red; */
  margin-left: 0px;
  margin-top: 2px;
`;

const CommentButton = styled.button`
  margin-top: 2px;
  margin-bottom: 8px;
  margin-left: 0px;
  padding: 4px 5px;
  border: none;
  border-radius: 6px;
  background: none;
  font-size: 15px;
  font-weight: 550;
  color: MediumPurple;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
    background: lightgray;
  }
`;

const CommentFormButton = styled.div`
  /* background: red; */
  margin-top: 20px;
`;

const CommentForm = styled.div`
  display: flex;
  align-items: center;
  margin-top: 20px;
  // border-top: 1px dashed gray;
  // background: lightgray;
`;

const Name = styled.div`
  margin-right: 10px;
  color: hotpink;
  font-size: 15px;
`;

const CommentInput = styled.textarea`
  margin-right: 10px;

  outline: none;
  border: none;
  // padding-bottom: 0.5rem;
  padding-left: 5px;
  // margin-bottom: 1rem;
  border-bottom: 1px solid ${palette.gray[4]};
  width: 70%;
  box-sizing: border-box;
  font-size: 15px;
  font-family: "Noto Sans KR";

  @media (max-width: 550px) {
    width: 60%;
  }

  @media (max-width: 400px) {
    width: 50%;
  }
`;

const GoList = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 20px;
  padding-bottom: 60px;
  // background: red;
`;

const timeDisplayFormat = {
  hour12: false,
  year: 'numeric',
  month: 'numeric',
  day: 'numeric',
  hour: '2-digit',
  minute: '2-digit',
  second: '2-digit',
};

const PostViewer = () => {
  const { user } = useContext(UserContext);
  const { post, setPost } = useContext(PostContext);
  const { postId } = useParams();
  
  const [comments, setComments] = useState([]);
  const [nextCommentsPage, setNextCommentsPage] = useState(null);
  const [commentOrder, setCommentOrder] = useState('oldest');
  const [commentContent, setCommentContent] = useState('');
  const [commentFormVisible, setCommentFormVisible] = useState(false);
  
  const commentInputRef = useRef(null);
  const navigate = useNavigate();
  const location = useLocation();
  const from = location.state?.from || "/postlist?page=1";
  
  useEffect(() => {
    setPost(null);
    setComments([]);

    const fetchPost = async () => {
      try {
        const response = await client.getPost(postId)
        log.debug('GET_POST_SUCCESS', response);
        setPost(response.data);
      } catch(e) {
        log.debug('GET_POST_FAILED', e);
      }
    };

    const fetchComments = async () => {
      try {
        const response = await client.getPostComments(postId);
        log.debug('GET_POST_COMMENTS_SUCCESS', response);
        setComments(response.data.results);
        setNextCommentsPage(response.data.next);
      } catch (e) {
        log.debug('GET_POST_COMMENTS_FAILED', e);
      }
    };

    fetchPost();
    fetchComments();
  }, [postId, setPost]);

  useEffect(() => {
    if (!commentInputRef.current) return;
    commentInputRef.current.style.height = 'auto';
    commentInputRef.current.style.height = `${commentInputRef.current.scrollHeight}px`;
  }, [commentContent]);

  useEffect(() => {
    if (commentFormVisible) {
      commentInputRef.current?.focus();
    }
  }, [commentFormVisible]);

  const handleUpdatePost = () => {
    setPost(prev => ({...prev, modify: true}));
    navigate('/write');
  };

  const handleDeletePost = async () => {
    const confirm = window.confirm('정말 삭제하시겠습니까?')
    if (!confirm) return;

    try {
      const response = await client.deletePost(postId);
      log.debug('POST_DELETE_SUCCESS', response);
      navigate('/postlist');      
    } catch (e) {
      log.debug('POST_DELETE_FAILED', e);
    }
  };

  const handleCommentOrder = async order => {
    if (order === commentOrder) return;
    
    try {
      const response = await client.getPostComments(postId, 1, order);
      log.debug('COMMENT_ORDER_CHANGE_SUCCESS', response);
      setCommentOrder(order);
      setComments(response.data.results);
      setNextCommentsPage(response.data.next);
    } catch(e) {
      log.debug('COMMENT_ORDER_CHANGE_FAILD', e);
    }
  };

  const handleLoadMoreComments = async () => {
    if (!nextCommentsPage) return;

    try {
      const response = await client.getPostComments(postId, nextCommentsPage);
      log.debug('LOAD_MORE_COMMENTS_SUCCESS', response);

      setComments(prev =>[
        ...prev,
        ...response.data.results,
      ]);
      setNextCommentsPage(response.data.next);
    } catch(e) {
      log.debug('LOAD_MORE_COMMENTS_FAILED', e);
    }
  };

  const handleCreateComment = async () => {
    const data = {
      content: commentContent,
    };

    try {
      const response = await client.createComment(postId, data);
      log.debug('POST_COMMENT_CREATE_SUCCESS', response);
      setComments(prev => [...prev, response.data]);
      setCommentContent('');
      setCommentFormVisible(false);
    } catch(e) {
      log.debug('POST_COMMENT_CREATE_FAILED', e);
    }
  };

  const handleAppendChild = createdComment => {
    setComments(prev => [...prev, createdComment]);
  };

  const handleUpdateChild = updatedComment => {
    setComments(prev =>
      prev.map(comment =>
        comment.id === updatedComment.id
          ? { ...comment, ...updatedComment }
          : comment
      )
    );
  };

  const handleRemoveChild = deletedComment => {
    setComments(prev =>
      prev.filter(comment => comment.id !== deletedComment.id)
    );
  };

  return (
    <div className="PostViewer">
      {post && (
        <PostViewerContainer>
          <PostHead>
            <h1>{post.title}</h1>
            <SubInfoBlock>
              <span><Author>{post.author_name}</Author></span>
              <span>{new Date(post.created_at).toLocaleString('ko-KR', timeDisplayFormat)}</span>
              {post.edited_at && <span>수정됨</span>}
            </SubInfoBlock>
          </PostHead>

          {(user.id === post.author ?
            <PostActionButtonsBlock> 
              <ActionButton onClick={handleUpdatePost}>수정</ActionButton>
              <ActionButton onClick={handleDeletePost}>삭제</ActionButton>
            </PostActionButtonsBlock>
            : null
          )}

          <PostContent dangerouslySetInnerHTML={{ __html: post.content }} />          
          
          <PostReactionsBlock><PostReactions user={user} post={post} /></PostReactionsBlock>

          <CommentBlock>
            <CommentOrder>
              <OrderButton
                $selected={commentOrder === 'oldest'}
                onClick={() => handleCommentOrder('oldest')}
              >
                등록순
              </OrderButton>
              <OrderButton
                $selected={commentOrder === 'latest'}
                onClick={() => handleCommentOrder('latest')}
              >
                최신순
              </OrderButton>
            </CommentOrder>

            {comments.map(comment => (
              <CommentItem
                key={comment.id}
                comment={comment}
                user={user}
                postId={postId}
                onAppendSibling={handleAppendChild}
                onUpdateSelf={handleUpdateChild}
                onRemoveSelf={handleRemoveChild}
              />
            ))}

            {nextCommentsPage && (
              <CommentButtonBlock>
                <CommentButton onClick={handleLoadMoreComments}>댓글 더보기 ▼</CommentButton>
              </CommentButtonBlock>
            )}          

            <CommentFormButton>
              <Button onClick={() => setCommentFormVisible(prev => !prev)}>
                {commentFormVisible ? '닫기' : '댓글달기'}
              </Button>
            </CommentFormButton>

            {commentFormVisible && (
              <CommentForm>
                {user.profile_url ?
                  <UserURLImage>
                    <img src={user.profile_url} alt="url-image" width="100%" style={{ borderRadius: "50%"}}/>
                  </UserURLImage> :
                  <UserImage><img src={userImage} alt="user-image" width="100%" /></UserImage>
                }            

                <Name>{user.name}</Name>
                <CommentInput 
                  ref={commentInputRef}
                  rows={1}
                  style={{ resize: "none", overflow: "hidden" }}
                  placeholder="댓글달기" 
                  value={commentContent} 
                  onChange={e => setCommentContent(e.target.value)} 
                />
                <ActionButton onClick={handleCreateComment}>등록</ActionButton>
              </CommentForm>
            )}
            
          </CommentBlock>

          <GoList>
            <ActionButton onClick={() => navigate(from)}>목록으로</ActionButton>
          </GoList>
        </PostViewerContainer>
      )}
    </div>
  );
};

export default PostViewer;